var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-avatar',_vm._g(_vm._b({class:("solid-border " + _vm.flagType + " mx-1"),attrs:{"size":_vm.size}},'v-avatar',attrs,false),on),[_c('v-icon',{class:("" + _vm.flagType)},[_vm._v(_vm._s(_vm.icon))])],1)]}}])},[_c('span',{domProps:{"textContent":_vm._s(_vm.tooltipMessage)}})])}
var staticRenderFns = []

export { render, staticRenderFns }